import { memo } from "react"
import { IconProps } from "./interfaces/IconProps.interface"

const DocFill = memo((props: IconProps) => {
    const { color = "#FFF", ...rest } = props
    return (
        <svg width={14} height={14} viewBox="0 0 14 14" fill="none" {...rest}>
            <path
                d="M11.6667 12.8333H2.33333C2.17862 12.8333 2.03025 12.7719 1.92085 12.6625C1.81146 12.5531 1.75 12.4047 1.75 12.25V1.75C1.75 1.59529 1.81146 1.44692 1.92085 1.33752C2.03025 1.22812 2.17862 1.16667 2.33333 1.16667H11.6667C11.8214 1.16667 11.9697 1.22812 12.0791 1.33752C12.1885 1.44692 12.25 1.59529 12.25 1.75V12.25C12.25 12.4047 12.1885 12.5531 12.0791 12.6625C11.9697 12.7719 11.8214 12.8333 11.6667 12.8333ZM4.66667 4.08333V5.25H9.33333V4.08333H4.66667ZM4.66667 6.41667V7.58333H9.33333V6.41667H4.66667ZM4.66667 8.75V9.91667H9.33333V8.75H4.66667Z"
                fill={color}
            />
        </svg>
    )
})
export default DocFill
